<template>
  <div class="main_wrap">
    <header>
      <Navigator :routeList="navigate" />
    </header>
    <main class="main-content">
      <iframe
        :src="`${iframeUrl}/resources?source=AFTER_CLASS&chapterId=${chapterId}&courseId=${courseId}&clazzId=${classId}&grade=${grade}&token=${token}&questionIds=${questionIds}&clientType=pc`"
        :onerror="loadError"
        frameborder="0"
      ></iframe>
    </main>
  </div>
</template>

<script>
import { iframeUrl } from "@/config/env";
import Navigator from "@/components/navigate.vue";

export default {
  name: "classStudyCondition",
  components: {
    Navigator,
  },
  computed: {
    navigate() {
      let arr = [];
      if (this.questionIds) {
        arr = [
          {
            name: "我的文件",
            url: `/mine/myDocument`,
          },
          { name: "班级学情", isCurrent: true },
        ];
      } else {
        arr = [
          { name: "首页", url: "/course" },
          {
            name: "全部课程",
            routeName: "courseList",
            params: {
              isNew: true,
            },
          },
          {
            name: "课程详情",
            url: `/course/subjectDetail/${this.courseId}?teachingAuxiliaryId=${this.teachingAuxiliaryId}&target=resourse`,
          },
          { name: "班级学情", isCurrent: true },
        ];
      }
      return arr;
    },
  },
  data() {
    return {
      iframeUrl: "",
      courseId: "",
      chapterId: "",
      classId: "",
      token: "",
      grade: "",
      teachingAuxiliaryId: "",
      questionIds: "",
    };
  },
  methods: {
    loadError() {
      alert("加载失败");
    },
    loadData() {
      const query = this.$route.query;
      this.iframeUrl = iframeUrl;
      this.courseId = query.courseId || "";
      this.chapterId = query.chapterId;
      this.classId = query.classId || "";
      this.grade = query.grade;
      this.token = localStorage.userToken;
      this.teachingAuxiliaryId = query.teachingAuxiliaryId || "";
      this.questionIds = query.questionIds || "";
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
<style lang="scss" scoped>
.main_wrap {
  width: 100%;
  height: 100%;

  header {
    margin-bottom: 2rem;
  }

  .main-content {
    background-color: #fff;
    width: 100%;
    height: calc(100vh - 14rem);
    // height: 800px;
    iframe {
      height: 100%;
      width: 100%;
    }
  }
}
</style>